import React from "react"
import tw, { styled } from "twin.macro"

const SlatGroup = ({ children, ...props }) => (
  <Style className="slat-group" {...props}>
    {children}
  </Style>
)
export default SlatGroup

const Style = styled.div`
  background-color: var(--light);
  box-shadow: 0 0 1vw rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100vw;
  max-width: 1000px;
  flex-wrap: nowrap;

  ${tw`sm:mx-auto sm:borderRadius[.5em] sm:w-auto justify-center`}

  > .slat + .slat::before {
    content: "";
    height: 70%;
    width: 1px;
    ${tw`bg-silver`}
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  > a {
    display: block;
    text-decoration: none;
    flex: 1;
    outline: none;

    &:focus > .slat svg,
    &:focus > .slat h4 {
      ${tw`text-orange`}
    }
  }
`
